// extracted by mini-css-extract-plugin
export default {"uploadButton":"upload_uploadButton__4yT40"};